//-- React Standard
import { Badge, Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Fade, Row, FormGroup, Label, Input } from 'reactstrap';
import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import Moment, { now } from 'moment';
import config from '../../config';
//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";

import { withStyles } from "@material-ui/core/styles";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import { orderActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { commonFunctions } from "../Common/common";

//-- CSS for Material
const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    // error: {
    //     color: 'red',
    // },
    // loaderImg: {
    //     margin: '0 auto',
    //     display: 'block',
    //     width: '250px'
    // },
    // boldText: {
    //     fontWeight: 'bold'
    // },
    // pageImg: {
    //     width: '70px',
    //     height: '70px',
    //     position: 'relative',
    //     padding: '10px'
    // },
    // removeImg: {
    //     position: 'absolute',
    //     top: '-7px',
    //     right: '-7px',
    //     padding: '0px 7px 0px 7px',
    //     border: '1px solid #a09d9d',
    //     background: '#c1c1c1',
    //     borderRadius: '50%',
    //     fontWeight: 'bold',
    //     cursor: 'pointer',
    //     color: '#fff'
    // },
    // borderedImg: {
    //     position: 'relative',
    //     width: '70px',
    //     height: '70px',
    //     border: '1px #dad7d7 solid',
    //     borderRadius: '10px',
    //     float: 'left',
    //     marginBottom: '15px',
    //     marginRight: '15px'
    // },
    tableImg: {
        width: '50px',
        height: '50px',
        position: 'relative',
        padding: '3px'
    }
});

class OrderDetails extends Component {
    constructor(props) {
        super(props);
        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.state = {
            accordion: [false, false, false],
            orderData: [],
            markOrderStatus: false,
            isShopkeeper: false,
            rejectOrder: false,
            rejecting: false,
            orderComplete: false,
            enableDelete: false,
            deductedAmount: 0,
            noteForDeductedAmount: ''

        };
    }

    //react js lifecycle method
    componentDidMount() {
        this.getUpdatedOrderData();
    }

    //common function to get order updated
    getUpdatedOrderData = () => {
        const { dispatch } = this.props;
        const { match } = this.props;
        const orderId = match.params.id;
        let userData = JSON.parse(sessionStorage.getItem('user'));

        let postData = {};
        postData.orderId = orderId;
        if (userData.role_type[0] == 'shopkeeper') {
            this.setState({ isShopkeeper: true })
        }

        dispatch(orderActions.getAllOrders(apiConstants.GET_ORDER_DETAILS, postData));
    }

    /*
   * componentWillReceiveProps - Whenever Props change, it will call and store data
   * update the state values with new props values, this method will get called whenever any change happens to props values
   */
    componentWillReceiveProps(props) {
        if (props.getAllOrders) {
            if (props.getAllOrders.orderList !== undefined &&
                props.getAllOrders.orderList.data !== undefined &&
                props.getAllOrders.orderList.data.allData[0] !== undefined) {
                this.setState({ orderData: props.getAllOrders.orderList.data.allData[0] })
            }
        }

        //when order got deleted
        if (props.markOrder) {
            if (props.markOrder.deleteResponse !== undefined &&
                props.markOrder.deleteResponse.data !== undefined &&
                props.markOrder.deleteResponse.data.success !== undefined &&
                props.markOrder.deleteResponse.data.success == true) {
                if (this.state.markOrderStatus == true) {
                    this.setState({ markOrderStatus: false })
                    this.getUpdatedOrderData();
                }
            }
        }

        //when order action perform
        if (props.markOrderAccepted) {
            if (
                props.markOrderAccepted.accepted !== undefined &&
                props.markOrderAccepted.accepted &&
                this.state.acceptOrder === true
            ) {
                this.setState({ acceptOrder: false, orderData: [] });
                this.getUpdatedOrderData();
            }

            //if order mark as rejected
            if (
                props.markOrderAccepted.accepted !== undefined &&
                props.markOrderAccepted.accepted &&
                this.state.rejectOrder === true &&
                this.state.rejecting === true
            ) {
                this.setState({ rejecting: false, rejectOrder: false });
                this.getUpdatedOrderData();
            }

            //if order mark as complete and release payment
            if (
                props.markOrderAccepted.accepted !== undefined &&
                props.markOrderAccepted.accepted &&
                this.state.orderComplete === true
            ) {
                this.setState({ orderComplete: false });
                this.getUpdatedOrderData();
            }
        }
    }

    toggleAccordion(tab) {
        const prevState = this.state.accordion;
        const state = prevState.map((x, index) => tab === index ? !x : false);

        this.setState({
            accordion: state,
        });
    }

    //method to mark a order paid, if amount already not paid by the customer
    markAsPaid = (orderId) => {
        let ordrObj = {}
        ordrObj.orderId = orderId;
        const { dispatch } = this.props;
        dispatch(orderActions.markOrderPaid(apiConstants.MARK_ORDER_PAID, ordrObj));
        this.setState({ markOrderStatus: true })

    }

    //-- accept a order by shopkeeper
    acceptTheOrder = (orderId, purchaseType) => {
        const { dispatch } = this.props;
        this.setState({ acceptOrder: true })

        var obj = {}
        obj.orderId = orderId;
        //if (purchaseType == "pickup") { obj.orderStatus = "preparing"; }
        dispatch(orderActions.markOrderAccepted(apiConstants.MARK_ORDER_ACCEPTED, obj));

    }

    //reject a orders by shopkeeper
    deletePopupOpen = (orderId) => { this.setState({ enableDelete: true, deleteOrderId: orderId }) }
    closeDeletePopup = () => {
        this.setState({ enableDelete: false, deleteOrderId: false })
    }
    rejectTheOrder = () => {
        const { dispatch } = this.props;

        if (this.state.deleteOrderId) {
            var obj = {}
            obj.orderId = this.state.deleteOrderId;
            dispatch(orderActions.markOrderAccepted(apiConstants.MARK_ORDER_REJECTED, obj));
            this.setState({ rejectOrder: true, rejecting: true, enableDelete: true })
            this.closeDeletePopup();
        }

    }

    //mark order prepaired
    orderPrepaired = (orderId, purchaseType) => {
        const { dispatch } = this.props;
        this.setState({ acceptOrder: true })

        var obj = {}
        obj.orderId = orderId;
        // if (purchaseType == "pickup") { obj.orderStatus = "preparing"; }
        // dispatch(orderActions.markOrderAccepted(apiConstants.MARK_ORDER_PREPAIRED, obj));

        if (purchaseType == "pickup") { obj.orderStatus = "preparing"; }
        dispatch(orderActions.markOrderAccepted(apiConstants.ORDER_COMPLETE, obj));
    }

    //order complete from shopkeeper end
    orderComplete = (orderId, purchaseType) => {
        const { dispatch } = this.props;
        this.setState({ orderComplete: true })

        var obj = {}
        obj.orderId = orderId;
        if (purchaseType == "pickup") { obj.orderStatus = "readyToPickup"; }
        dispatch(orderActions.markOrderAccepted(apiConstants.ORDER_COMPLETE, obj));
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }
    orderCompleteWithDeduction = (orderId, purchaseType) => {
        const { dispatch } = this.props;
        this.setState({ orderComplete: true })

        var obj = {
            deductedAmount: this.state.deductedAmount,
            noteForDeductedAmount: this.state.noteForDeductedAmount
        }
        obj.orderId = orderId;
        // if (purchaseType == "rental") { obj.orderStatus = "rental_complete_with_deduction"; }
        dispatch(orderActions.markOrderAccepted(apiConstants.ORDER_COMPLETED_BY_SHOPKEEPER, obj));
    }

    //-- Main function
    render() {
        const { classes, match, history } = this.props;
        const { orderData } = this.state;
        const orderDate = new Date(orderData.createdAt);

        const dateFormat = { year: 'numeric', month: 'long', day: 'numeric' };
        const timeFormat = { hour: '2-digit', minute: '2-digit' };
        const { siteConstants } = this.props.language;

        //var statusArray = ["pending", "accepted_by_shopkeeper", "order_completed_by_shopkeeper"];
        let cls = 'btn btn-payment-canceled';
        let totalItemsAmount = 0;
        return (
            <div id="wrapper">
                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/shop-list">{siteConstants.MENU_ORDERS}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    Details
                                </li>


                            </ol>
                        </nav>


                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">
                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <div>
                                    <div className="h3CustomeHeading">
                                        #{orderData !== undefined && orderData.orderNumber !== undefined ? orderData.orderNumber : ""}
                                    </div>
                                </div>
                                <div>
                                    <a href="javascript:void(0)" className="darkLink"
                                        onClick={() => this.props.history.goBack()}><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </div>
                                {/*<div className="textAlignRight">
                                    <a href="javascript:void(0)" className="darkLink">
                                        <i class="fa fa-angle-left"></i>
                                    </a>
                            &nbsp;&nbsp;
                            <a href="javascript:void(0)" className="darkLink">
                                        <i class="fa fa-angle-right"></i>
                                    </a>
                                </div>*/}
                            </div>

                            <div className="row">
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Card className="mb-2">
                                                <CardHeader>
                                                    <Row>
                                                        <Col xs="6">
                                                            <strong>{siteConstants.LABEL_ORDER_DATE}</strong><br />
                                                            {orderDate && orderDate !== undefined ? orderDate.toLocaleString("en-US", dateFormat) + " At " + orderDate.toLocaleString("en-US", timeFormat) : ''}<br />
                                                            {siteConstants.LABEL_ORDER_ITEMS} -
                                                            {
                                                                orderData.ordersData !== undefined ? orderData.ordersData.length : ""
                                                            }<br />

                                                            <button disabled="true" className={
                                                                orderData.paymentStatus == "pending" ?
                                                                    cls = "btn btn-payment-pending" :
                                                                    orderData.paymentStatus == "complete" ?
                                                                        cls = "btn btn-payment-paid" :
                                                                        orderData.paymentStatus == "delivery_rejected_by_customer" ?
                                                                            cls = "btn btn-payment-canceled" : ''
                                                            }>{commonFunctions.paymentStatus(orderData.paymentStatus)}</button>
                                                            {/* {
                                                                orderData.paymentStatus !== undefined && orderData.paymentStatus == "complete" ?
                                                                    (<button disabled="true" className="btn btn-payment-paid">{siteConstants.LABEL_PAYMENT_PAID}</button>)
                                                                    :
                                                                    (<button className="btn btn-payment-pending">{siteConstants.LABEL_PAYMENT_PENDING}</button>)
                                                            } */}


                                                        </Col>
                                                        <Col xs="6" style={{ "text-align": "right" }}>
                                                            <strong>{siteConstants.LABEL_SHIPPING_AT}</strong><br />
                                                            {
                                                                orderData.address !== undefined && orderData.address ?
                                                                    (
                                                                        <Fragment>
                                                                            {orderData.usersData[0].firstname}&nbsp;{orderData.usersData[0].lastname} <br />
                                                                            {orderData.address.roomNumber}&nbsp;{orderData.address.buildingName}<br />
                                                                            {orderData.usersData[0] !== undefined ? orderData.usersData[0].mobile_number : ""}
                                                                        </Fragment>
                                                                    )
                                                                    :
                                                                    ("")
                                                            }
                                                            <br />
                                                        </Col>
                                                    </Row>

                                                </CardHeader>
                                                <CardBody>
                                                    <Row className="mb-2">
                                                        <Col xs="3">
                                                            <strong>{siteConstants.LABEL_ORDER_ITEMS_CAPS} ({orderData !== undefined && orderData.ordersData !== undefined ? orderData.ordersData.length : ""})</strong>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4">
                                                            
                                                        {
                                                            orderData !== undefined &&
                                                            orderData.ordersData !== undefined &&
                                                            orderData.ordersData.length > 0 &&
                                                            orderData.ordersData.map((order) => {
                                                                totalItemsAmount += order.pricePerItem * order.quantity
                                                                return (
                                                                    <Fragment>
                                                                        <Col xs="1" style={{ textAlign: "right" }}>
                                                                            {order.productData !== undefined && order.productData !== null && order.productData.mainImage !== undefined && order.productData.mainImage !== null ?
                                                                                <img src={`${config.imgPath}` + '/uploads/products/' + order.productData.mainImage} className={classes.tableImg} />
                                                                                :
                                                                                <i className="fa fa-laptop"></i>
                                                                            }
                                                                        </Col>
                                                                        <Col xs="6">
                                                                            <FormGroup>
                                                                                <p className="fontBold">{order.productData !== undefined && order.productData !== null && order.productData.title}</p>
                                                                                {/* <div>{siteConstants.MENU_SETTINGS_DESCRIPTION}</div> */}
                                                                            </FormGroup>
                                                                        </Col>
                                                                        <Col xs="3">
                                                                            <FormGroup>
                                                                                {config.currencyCode}{order.pricePerItem} x {order.quantity}
                                                                            </FormGroup>
                                                                        </Col>
                                                                        <Col xs="2">
                                                                            <FormGroup>
                                                                                
                                                                                {config.currencyCode}{(totalItemsAmount).toFixed(2)}
                                                                            </FormGroup>
                                                                        </Col>


                                                                        {/*add ons*/}
                                                                        {
                                                                            order.addons !== undefined &&
                                                                            order.addons.length > 0 && order.addons.map((data) => {


                                                                                return (
                                                                                    <Fragment>
                                                                                        <Col xs="1" style={{ textAlign: "right" }}> </Col>
                                                                                        <Col xs="6">{data.addonTitle}</Col>
                                                                                        <Col xs="3">  {config.currencyCode}{data.addonPrice} x {order.quantity}</Col>
                                                                                        <Col xs="2">
                                                                                            <FormGroup>
                                                                                                {config.currencyCode}{data.addonPrice * order.quantity}
                                                                                            </FormGroup>
                                                                                        </Col>
                                                                                    </Fragment>
                                                                                )
                                                                            })

                                                                        }

                                                                        {/* check if discount was applied on this order-product */}
                                                                        {
                                                                            order.priceObject !== undefined &&
                                                                                order.priceObject.discount !== undefined &&
                                                                                order.priceObject.discount > 0 ?

                                                                                <Fragment>
                                                                                    <Col xs="1" style={{ textAlign: "right" }}> </Col>
                                                                                    <Col xs="6">{siteConstants.GEN_DISCOUNT}</Col>
                                                                                    <Col xs="3"></Col>
                                                                                    <Col xs="2">
                                                                                        <FormGroup>
                                                                                            {config.currencyCode}{parseFloat(order.priceObject.discount.toFixed(2))}
                                                                                        </FormGroup>
                                                                                    </Col>
                                                                                </Fragment> : ""

                                                                        }

                                                                        {/* check if any coupon applied on the order */}

                                                                        {
                                                                            order.priceObject !== undefined &&
                                                                                order.priceObject.couponDiscount !== undefined &&
                                                                                order.priceObject.couponDiscount > 0 ?

                                                                                <Fragment>
                                                                                    <Col xs="1" style={{ textAlign: "right" }}> </Col>
                                                                                    <Col xs="6">{siteConstants.GEN_COUPON}</Col>
                                                                                    <Col xs="3"></Col>
                                                                                    <Col xs="2">
                                                                                        <FormGroup>
                                                                                            {config.currencyCode}{parseFloat(order.priceObject.couponDiscount.toFixed(2))}
                                                                                        </FormGroup>
                                                                                    </Col>
                                                                                </Fragment> : ""

                                                                        }

                                                                        {/*Display product notes*/}
                                                                        {
                                                                            order.productNotes !== undefined &&
                                                                                order.productNotes !== '' &&
                                                                                order.productNotes !== null ?

                                                                                <Fragment>
                                                                                    <Col xs="12" style={{ paddingTop: "15px", paddingBottom: "15px" }}><b>{siteConstants.CUSTOMER_PRODUCT_NOTES} :</b> {order.productNotes}</Col>
                                                                                </Fragment> : ""
                                                                        }


                                                                    </Fragment>
                                                                )
                                                            })
                                                        }
                                                    </Row>

                                                </CardBody>
                                                <CardFooter className="textAlignRight">
                                                    {/* <button className="btn btn-fulfilled">{siteConstants.LABEL_MARK_FULLFILLED}</button> */}
                                                </CardFooter>
                                            </Card>

                                            <Card className="mb-2">
                                                <CardHeader>
                                                    <strong> {siteConstants.LABEL_PAYMENT}
                                                        {/* {
                                                        orderData.paymentStatus !== undefined && orderData.paymentStatus == "complete" ?
                                                            (siteConstants.LABEL_PAYMENT_PAID)
                                                            :
                                                            (siteConstants.LABEL_PAYMENT_PENDING)
                                                    } */}
                                                    </strong>
                                                </CardHeader>
                                                <CardBody>

                                                    {/*display order total*/}
                                                    <Row className="mb-4">
                                                        <Col xs="3">
                                                            {siteConstants.LABEL_ORDER_TOTAL}
                                                        </Col>
                                                        <Col xs="7">

                                                        </Col>
                                                        <Col xs="2">
                                                            {config.currencyCode} {totalItemsAmount}
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-4">
                                                        <Col xs="3">
                                                            Delivery Charges
                                                        </Col>
                                                        <Col xs="7">

                                                        </Col>
                                                        <Col xs="2">
                                                            {config.currencyCode} {orderData.deliveryCharge !== undefined ? orderData.deliveryCharge : 0}
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-4">
                                                        <Col xs="3">
                                                            Security Amount
                                                        </Col>
                                                        <Col xs="7">

                                                        </Col>
                                                        <Col xs="2">
                                                            {config.currencyCode} {orderData.securityAmount !== undefined ? orderData.securityAmount : 0}
                                                        </Col>
                                                    </Row>

                                                    {/*display service charge*/}
                                                    <Row className="mb-4">
                                                        <Col xs="3">
                                                            {siteConstants.ORDER_SERVICE_CHARGE}
                                                        </Col>
                                                        <Col xs="7">

                                                        </Col>
                                                        <Col xs="2">
                                                            {config.currencyCode} {orderData.serviceCharge !== undefined ? orderData.serviceCharge : 0}
                                                        </Col>
                                                    </Row>

                                                    {/*display tax charge*/}
                                                    <Row className="mb-4">
                                                        <Col xs="3">
                                                            {siteConstants.LABEL_TAX}
                                                        </Col>
                                                        <Col xs="7">

                                                        </Col>
                                                        <Col xs="2">
                                                            {config.currencyCode}{orderData.totalTax !== undefined ? orderData.totalTax : 0}
                                                        </Col>
                                                    </Row>

                                                    {/*display tax charge*/}
                                                    {/* {
                                                        orderData.codDeliveryCharge !== undefined && orderData.codDeliveryCharge > 0 ?
                                                            <Row className="mb-4">
                                                                <Col xs="3">
                                                                    {siteConstants.LABEL_COD_CHARGE_ORDER}
                                                                </Col>
                                                                <Col xs="7">

                                                                </Col>
                                                                <Col xs="2">
                                                                    {config.currencyCode} {orderData.codDeliveryCharge !== undefined ? orderData.codDeliveryCharge : 0}
                                                                </Col>
                                                            </Row> : ''
                                                    } */}


                                                    {/*display total paid*/}
                                                    <Row className="mb-4">
                                                        <Col xs="3">
                                                            <b>{siteConstants.ORDER_TOTAL_PAID}</b>
                                                        </Col>
                                                        <Col xs="7">

                                                        </Col>
                                                        <Col xs="2">
                                                            {config.currencyCode}{orderData.pricepaid}
                                                        </Col>
                                                    </Row>


                                                </CardBody>
                                                <CardFooter className="textAlignRight">

                                                    {
                                                        orderData.paymentStatus !== undefined && orderData.paymentStatus == "pending" && orderData.status == 'delivered' ?
                                                            (<button className="btn btn-fulfilled" onClick={(e) => this.markAsPaid(orderData._id)}>{siteConstants.LABEL_MARK_PAID}</button>)
                                                            :
                                                            ''
                                                    }

                                                </CardFooter>
                                            </Card>

                                            {/*order hitory section*/}
                                            <Card className="mb-2">
                                                <CardHeader>
                                                    <strong> {siteConstants.ORDER_HITORY}</strong>
                                                </CardHeader>
                                                <CardBody>

                                                    {
                                                        orderData.createdAt && orderData.createdAt !== null ?
                                                            <Fragment>
                                                                <p><b>{siteConstants.ORDER_AT} :</b> {Moment(orderData.createdAt).format(config.FullDateFormat)}</p>
                                                            </Fragment>
                                                            :
                                                            <p><b>{siteConstants.ORDER_AT} :</b> NA </p>
                                                    }

                                                    {
                                                        orderData.shopAcceptedAt && orderData.shopAcceptedAt !== null ?
                                                            <Fragment>
                                                                <p><b>{siteConstants.ORDER_SHOP_ACEPTED_AT} :</b> {Moment(orderData.shopAcceptedAt).format(config.FullDateFormat)}</p>
                                                            </Fragment>
                                                            :
                                                            <p><b>{siteConstants.ORDER_SHOP_ACEPTED_AT} :</b> NA </p>
                                                    }

                                                    {
                                                        orderData.acceptedAt && orderData.acceptedAt !== null ?
                                                            <Fragment>
                                                                <p><b>{siteConstants.ORDER_DELIVERY_BOY_ACCEPTED_AT} :</b> {Moment(orderData.acceptedAt).format(config.FullDateFormat)}</p>
                                                            </Fragment>
                                                            :
                                                            <p><b>{siteConstants.ORDER_DELIVERY_BOY_ACCEPTED_AT} :</b> NA </p>
                                                    }

                                                    {
                                                        orderData.shopPrepairedAt && orderData.shopPrepairedAt !== null ?
                                                            <Fragment>
                                                                <p><b>{siteConstants.ORDER_SHOP_PREAPRED_AT} :</b> {Moment(orderData.shopPrepairedAt).format(config.FullDateFormat)}</p>
                                                            </Fragment>
                                                            :
                                                            <p><b>{siteConstants.ORDER_SHOP_PREAPRED_AT} :</b> NA </p>
                                                    }

                                                    {
                                                        orderData.pickedForDeliveryAt && orderData.pickedForDeliveryAt !== null ?
                                                            <Fragment>
                                                                <p><b>{siteConstants.ORDER_PICKED_BOY_ACCEPTED_AT} :</b> {Moment(orderData.pickedForDeliveryAt).format(config.FullDateFormat)}</p>
                                                            </Fragment>
                                                            :
                                                            <p><b>{siteConstants.ORDER_PICKED_BOY_ACCEPTED_AT} :</b> NA </p>
                                                    }

                                                    {
                                                        orderData.deliveredAt && orderData.deliveredAt !== null ?
                                                            <Fragment>
                                                                <p><b>{siteConstants.ORDER_DELIVERY_BOY_DELIVERED_AT} :</b> {Moment(orderData.deliveredAt).format(config.FullDateFormat)}</p>
                                                            </Fragment>
                                                            :
                                                            <p><b>{siteConstants.ORDER_DELIVERY_BOY_DELIVERED_AT} :</b> NA </p>
                                                    }


                                                    {
                                                        orderData.completedAt && orderData.completedAt !== null ?
                                                            <Fragment>
                                                                <p><b>{siteConstants.ORDER_COMPLETE_AT} :</b> {Moment(orderData.completedAt).format(config.FullDateFormat)}</p>
                                                            </Fragment>
                                                            :
                                                            <p><b>{siteConstants.ORDER_COMPLETE_AT} :</b> NA </p>
                                                    }



                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">

                                    <div className="row">
                                        <div className="col-md-12">

                                            {/* display order status here*/}
                                            <Card className="mb-2">
                                                <CardHeader>
                                                    <div className="row"> <div className="col-md-9"> <strong>{siteConstants.LABEL_STATUS}</strong> </div> </div>
                                                </CardHeader>
                                                <CardBody> {commonFunctions.orderStatus(orderData.status, siteConstants)} </CardBody>
                                            </Card>
                                            {
                                                this.state.isShopkeeper === true &&
                                                <Card className="mb-2">
                                                    <CardHeader>
                                                        <div className="row"> <div className="col-md-9"> <strong>{siteConstants.LABEL_ACTION}</strong> </div> </div>
                                                    </CardHeader>
                                                    <CardBody>

                                                        {
                                                            orderData.status == "pending" && this.state.isShopkeeper == true ?
                                                                <Fragment>
                                                                    <button className="redBtn" onClick={(e) => this.acceptTheOrder(orderData._id, orderData.purchaseType)}>Accept Order</button>  &nbsp;

                                                                    {this.state.rejecting === true ?
                                                                        <div class="fa-3x" style={{ textAlign: "center" }}>
                                                                            <i class="fas fa-spinner fa-spin"></i>
                                                                        </div> :
                                                                        <button className="redBtn" onClick={(e) => this.deletePopupOpen(orderData._id)}>Reject Order</button>
                                                                    }

                                                                </Fragment>
                                                                : ""
                                                        }
                                                        {
                                                            orderData.status == "rejected_by_shopkeeper" && this.state.isShopkeeper == true ?
                                                                <div><b>Rejected by the shopkeeper</b></div>
                                                                : ""
                                                        }

                                                        {
                                                            orderData.status == "accepted_by_delivery_boy" && this.state.isShopkeeper == true ?
                                                                <button className="redBtn" onClick={(e) => this.orderPrepaired(orderData._id, orderData.purchaseType)}>Order Prepaired</button>
                                                                : ""
                                                        }

                                                        {
                                                            orderData.status == "preparing" && this.state.isShopkeeper == true ?
                                                                <button className="redBtn" onClick={(e) => this.orderPrepaired(orderData._id, orderData.purchaseType)}>Order Prepaired</button>
                                                                : ""
                                                        }
                                                        {
                                                            (orderData.status == "rental_returning_deposit_to_shopkeeper" && this.state.isShopkeeper == true) ?
                                                                <>
                                                                    <label>If any defect in returned product, deduct below amount</label>
                                                                    <input
                                                                        type="text"
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        placeholder="Deducted Amount"
                                                                        className="form-control"
                                                                        name="deductedAmount"
                                                                    />
                                                                    <input
                                                                        type="text"
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        placeholder="Note forDeducted Amount"
                                                                        className="form-control"
                                                                        name="noteForDeductedAmount"
                                                                    />
                                                                    <button className="redBtn" onClick={(e) => this.orderCompleteWithDeduction(orderData._id, orderData.purchaseType)}>Mark Complete</button>
                                                                </>
                                                                : ""
                                                        }
                                                        {
                                                            orderData.status == "readyToPickup" && this.state.isShopkeeper == true && orderData.purchaseType === "pickup" ?
                                                                <button className="redBtn" onClick={(e) => this.orderComplete(orderData._id, orderData.purchaseType)}>Mark Complete</button>
                                                                : ""
                                                        }

                                                    </CardBody>
                                                </Card>
                                            }

                                            {/*order note section*/}
                                            {/*<Card>
                                                <CardHeader>

                                                    <div className="row">
                                                        <div className="col-md-9">
                                                            <strong>{siteConstants.CUSTOMER_ORDER_NOTES}</strong>
                                                        </div>
                                                    </div>
                                                </CardHeader>
                                                <CardBody>
                                                {orderData.orderNote !== undefined && orderData.orderNote ? orderData.orderNote : "NA"}
                                                </CardBody>
                                            </Card>*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}
                    {/* notify about delete */}
                    <Dialog open={this.state.enableDelete} aria-labelledby="delete-tax-notify" >
                        <DialogTitle className={classes.root}>{siteConstants.LABEL_SURE_DELETE_DISCOUNT_RECORD}</DialogTitle>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.rejectTheOrder(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>
                    <Footer />
                </div>
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getAllOrders, markOrder, language, getProduct, deleteProduct, markOrderAccepted } = state;
    return {
        getAllOrders,
        markOrder,
        language,
        getProduct,
        deleteProduct,
        markOrderAccepted
    };
}
//export default compose(withStyles(styles), connect(mapStateToProps))(OrderDetails);

const connectedMembership = connect(mapStateToProps)(withStyles(styles)(OrderDetails));
export { connectedMembership as OrderDetails };